import { render, staticRenderFns } from "./Filter.vue?vue&type=template&id=51138e1d"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"
import style0 from "./Filter.vue?vue&type=style&index=0&id=51138e1d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51138e1d')) {
      api.createRecord('51138e1d', component.options)
    } else {
      api.reload('51138e1d', component.options)
    }
    module.hot.accept("./Filter.vue?vue&type=template&id=51138e1d", function () {
      api.rerender('51138e1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/Filter.vue"
export default component.exports